exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Icon{display:inline-block;text-align:center;position:relative;vertical-align:middle;top:-1px}.Icon,.Icon i{transition:all .25s ease}.Icon--disabled{pointer-events:none}.Icon--tiny{font-size:12px;line-height:12px}.Icon--tiny.Icon--rounded{width:33px;height:33px}.Icon--small{font-size:18px}.Icon--small.Icon--rounded{width:33px;height:33px}.Icon--medium{font-size:35px}.Icon--medium.Icon--rounded{width:33px;height:33px}.Icon--large{font-size:35px}.Icon--large.Icon-rounded{width:44px;height:44px}.Icon--extraLarge{font-size:70px;line-height:70px}.Icon--extraLarge.Icon--rounded{width:66px;height:66px}.Icon--rounded{border-radius:50%}.Icon--centered,.Icon--rounded i{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.Icon--bordered{border:2px solid}.Icon--spacedLeft{margin-left:15px}.Icon--spacedRight{margin-right:15px}.Icon--branded{color:#ffa257;border-color:#ffa257}.Icon--branded:hover{color:#ffb478;border-color:#ffb478}.Icon--branded:active,.Icon--branded:focus{color:#ff913d;border-color:#ff913d}.Icon--accented{color:#08152e;border-color:#08152e}.Icon--accented:hover{color:#0d224a;border-color:#0d224a}.Icon--accented:active,.Icon--accented:focus{color:#040b18;border-color:#040b18}.Icon--shaded{color:#dcdcdc;border-color:#dcdcdc}.Icon--shaded:hover{color:#040b18;border-color:#040b18}.Icon--shaded:active,.Icon--shaded:focus{color:#dcdcdc;border-color:#dcdcdc}.Icon--light,.Icon--light:active,.Icon--light:focus,.Icon--light:hover{color:#fff;border-color:#fff}", ""]);

// exports
exports.locals = {
	"Icon": "Icon",
	"Icon--disabled": "Icon--disabled",
	"Icon--tiny": "Icon--tiny",
	"Icon--rounded": "Icon--rounded",
	"Icon--small": "Icon--small",
	"Icon--medium": "Icon--medium",
	"Icon--large": "Icon--large",
	"Icon-rounded": "Icon-rounded",
	"Icon--extraLarge": "Icon--extraLarge",
	"Icon--centered": "Icon--centered",
	"Icon--bordered": "Icon--bordered",
	"Icon--spacedLeft": "Icon--spacedLeft",
	"Icon--spacedRight": "Icon--spacedRight",
	"Icon--branded": "Icon--branded",
	"Icon--accented": "Icon--accented",
	"Icon--shaded": "Icon--shaded",
	"Icon--light": "Icon--light"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Icon/Icon.scss
 ** module id = 157
 ** module chunks = 0
 **/